import { Component } from "react";
import { Link } from 'react-router-dom'
import DisplaySchemeInfo from "./DisplaySchemeInfo";
import DisplayQuestionnaireInfo from "./DisplayQuestionnaireInfo";
import QuestionnaireRankingInfo from "./RankingManager/QuestionnaireRankingInfo";

class HalCompassManager extends Component{

    render(){
        const{query, schemes, criteria, profile, evaluationB, ranking} = this.props;

        let query_subtopic = query.get('subtopic')
        return(
            <div>
                <h3 className="text-left">HalCompass Manager</h3>

                <div className="tab">
                    <Link className={query_subtopic === 'scheme' ? 'tablinks active' : 'tablinks'} to="/systemmanager?topic=halcompass&subtopic=scheme">All Scheme</Link>
                    <Link className={query_subtopic === 'questionnaire' ? 'tablinks active' : 'tablinks'} to='/systemmanager?topic=halcompass&subtopic=questionnaire'>Questionnaire</Link>
                    <Link className={query_subtopic === 'ranking' ? 'tablinks active' : 'tablinks'} to='/systemmanager?topic=halcompass&subtopic=ranking'>Ranking</Link>
                </div>

                <div className="tabcontent">
                    <div style={{margin:'20px'}}>
                        {schemes && query_subtopic === 'scheme' ?
                        <DisplaySchemeInfo schemes={schemes} />
                        :schemes && query_subtopic === 'questionnaire' ? 
                        <DisplayQuestionnaireInfo schemes={schemes} query={query} criteria={criteria} profile={profile} evaluationB={evaluationB}/> 
                        :schemes && query_subtopic === 'ranking'?
                        <QuestionnaireRankingInfo schemes={schemes} ranking={ranking}/>
                        :<div>Loading...</div>}
                    </div>
                </div>
            </div>
        )
    }
        
    
}

export default HalCompassManager